import moment from 'moment'
const extend = require('extend')

export default {
  namespaced: true,
  state: {
    pageInfo: {
      currentPage: 1
    },
    categories: [],
    selectedCategories: [],
    orderBy: 'startDate asc',
    limit: 100,
    siteId: null,
    section: 'events',
    results: [],
    offset: 0
  },
  mutations: {
    UPDATE_PAGEINFO (state, pageInfo) {
      state.pageInfo = pageInfo
    },
    UPDATE_PAGE (state, number) {
      state.offset = state.offset + number
      state.pageInfo.currentPage = state.pageInfo.currentPage + number
    },
    UPDATE_RESULTS (state, results) {
      state.results = results
    },
    UPDATE_LIMIT (state, limit) {
      state.limit = limit
    },
    UPDATE_SECTION (state, section) {
      state.section = section
    },
    UPDATE_SITE_ID (state, siteId) {
      state.siteId = siteId
    },
    UPDATE_CATEGORIES (state, categories) {
      state.categories = categories
    },
    UPDATE_SELECTED_CATEGORIES (state, selectedCategories) {
      state.selectedCategories = selectedCategories
    }
  },
  getters: {
    queryCategories: state => {
      return state.selectedCategories.join(',')
    },
    offsetMultiplier: state => {
      return state.offset * 3
    },
    variables: (state, getters) => {
      const variables = {}

      if (state.selectedCategories.length) {
        const related = { relatedTo: state.selectedCategories }
        extend(variables, related)
      }

      const orderBy = { orderBy: state.orderBy }
      extend(variables, orderBy)

      const siteId = { siteId: state.siteId }
      extend(variables, siteId)

      const limit = { limit: state.limit }
      extend(variables, limit)

      const section = { section: state.section }
      extend(variables, section)

      const startMonth = moment().add(getters.offsetMultiplier, 'months')
      const startDateFormatted = startMonth.startOf('month').format('Y-MM-DD')

      const startDate = {
        startDate: '>= ' + startDateFormatted
      }

      extend(variables, startDate)

      return variables
    }
  }
}
